import moment from 'moment';

const dateTimeFormat = language => {
  switch (language) {
    case 'fr':
      return 'DD/MM/YYYY [à] HH:mm';
    case 'en':
      return 'L [at] LT';
    default:
      return 'DD/MM/YYYY [à] HH:mm';
  }
};

export const setEditorFieldValue = (type, value, language) => {
  if (value) {
    if (type === 'date_time') {
      return moment(value, 'YYYY-MM-DDTHH:mm').format(dateTimeFormat(language));
    } else if (type === 'date') {
      return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
    } else if (type.includes('float')) {
      return setEditorNumberValue(language, value, type);
    }
  }
  return value;
};

export const setEditorNumberValue = (language, value, type) => {
  return language === 'fr'
    ? (Math.round(value * 100) / 100 + '').replace(/\./g, ',')
    : Math.round(value * 100) / 100 + '';
};

export const setFunctionValue = (functionString, fullPaxFieldsData) => {
  //This code causes 'The Function constructor is eval' warning. It's ok.
  // eslint-disable-next-line no-new-func
  const createFunction = new Function('return ' + functionString)();
  const context = fullPaxFieldsData.reduce(
    (prev, next) => ({ ...prev, [next.id]: Number(next.value) }),
    {}
  );
  return createFunction(context);
};



// WEBPACK FOOTER //
// ./src/component/TaskCreator/Section/setEditorFieldValue.js